import { Controller } from "@hotwired/stimulus"
import { get, post, put, patch, destroy } from "@rails/request.js"
import Sortable from "../vendor/sortable.esm.min.js"

// Connects to data-controller="unterkartensort"
export default class extends Controller {
  static targets = ["unterkartenSortFormular"]

  	connect() {
		this.sortable = new Sortable(this.element, {
				animation: 150,
				handle: ".sort-element",
				dragClass: "bg-white",
				forceFallback: true,
				onEnd: () => this.updateUnterkartenreihenfolge()
		})
 	}

  	disconnect() {
		this.sortable?.destroy()
	}

  	updateUnterkartenreihenfolge() {
		this.unterkartenSortFormularTargets.forEach((unterkartenForm, index) => {
		const positionField = unterkartenForm.querySelector(".position_field")
		const newUnterkartenPosition = index + 1
		// Wenn im Hidden-Field nicht die neue/richtige Position steht:
		// -> Setze die neue Position ins Hidden-Field + sende update
		if (positionField.value != newUnterkartenPosition) {
			positionField.value = newUnterkartenPosition
			this.sendRequest(unterkartenForm.action, new FormData(unterkartenForm));
		}
		})
	}

  	sendRequest(url, formData) {
		patch(url, { responseKind: "turbo-stream", body: formData })
	}
}
